module.exports = __webpack_public_path__ + "static/media/29FUNOV13.a2fa9f61.jpg";